import ExcelTemplateDetailApp from "exceltemplate/Detail/app";
import ExcelTemplateListApp from "exceltemplate/List/App";
import ExcelTemplateNewApp from "exceltemplate/New/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const excelTemplateRoute: RouteObject = {
  path: "exceltemplate",
  children: [{
    path: ":mainArea",
    loader: () => viewModel,
    Component: ExcelTemplateListApp,
  }, {
    path: "detail/:id",
    loader: () => viewModel,
    Component: ExcelTemplateDetailApp,
  }, {
    path: ":mainArea/new",
    loader: () => viewModel,
    Component: ExcelTemplateNewApp,
  }]
};